import React, {Component} from 'react';
import axios from 'axios';
import './Referafriend.css';
class Referafriend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
        

    }
}
  render() {
    return <div>

  <div className="container ">

      <div className="text-center p-5">
            <a className="" href=""> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2" /></a>
            <h1 className="refer">Refer a Friend</h1>
            <p class="point">Use your unique code while signing up to get <b class="bld">$50</b> as wallet credit for both you and your friend</p>
            
            <div className="my-box">
              <h1 class="box-no">XZ7842</h1>
          {/* <input type="text-bdr" className=""  placeholder="" id=""/> */}
          </div>
          <div className=" ">
            
              <li class="copy green-link share mt-3"><a href="">Copy Unique Code</a></li>
              <li class="copy green-link share mt-2"><a href="">Share download link</a></li>
          
          </div>
      </div>

  </div>


    </div>
    }
}

export default Referafriend;
